module.exports = __webpack_public_path__ + "static/img/clearing_01.74ec9ea5.svg";